import * as React from 'react';

import { ProjectDiagramEntityDrawer } from 'src/containers/ProjectDiagram/ProjectDiagramEntityDrawer';
import { ProjectRuleOverviewDrawer } from 'src/containers/ProjectRuleOverviewDrawer/ProjectRuleOverviewDrawer';

export const ProjectDrawers: React.VFC = () => (
  <>
    <div className="sd-project-drawer-container">
      <ProjectDiagramEntityDrawer />
      <ProjectRuleOverviewDrawer />
    </div>
  </>
);
